// extracted by mini-css-extract-plugin
export default {"QuizContainer":"QuizContainer_QuizContainer__tN0Gd","content":"QuizContainer_content__Pwcju"};